import LanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import TutorialEvent from "../events/TutorialEvent";
import TutorialScreenMediator from "./shared/TutorialScreenMediator";

export default class TutorialSimInteractions extends TutorialScreenMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {LanguagePack} languagePack
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, mediatorManager) {
        super(target, dispatcher, layoutManager, clickEaterFactory, mediatorManager);
        this._languagePack = languagePack;
        this._mediatorManager = mediatorManager;
    }

    initialize() {
        super.initialize();

        this._target.popupTitle.text = this._languagePack.getText('tutorial.sim-interactions.popupTitle');
        this._target.popupContinueButton.text = this._languagePack.getText('tutorial.sim-interactions.popupContinueButton');
        this._target.popupTopic1Description.text = this._languagePack.getText('tutorial.sim-interactions.popupTopic1Description');
        this._target.popupTopic2Description.text = this._languagePack.getText('tutorial.sim-interactions.popupTopic2Description');
        this._target.popupTopic3Description.text = this._languagePack.getText('tutorial.sim-interactions.popupTopic3Description');
        this._target.exitTitleText.text = this._languagePack.getText('tutorial.sim-interactions.popupTopic1Title');
        this._target.pauseTitleText.text = this._languagePack.getText('tutorial.sim-interactions.popupTopic2Title');
        this._target.tutorialTitletext.text = this._languagePack.getText('tutorial.sim-interactions.popupTopic3Title');
        super.initializeButton("popupContinueButton", 'tutorial.sim-interactions.popupContinueButton');
    }

    _handleContinueButton() {
        super._handleContinueButton();
        this.dispatch(TutorialEvent.CLOSE_REQUEST);
    }
}